




































import { Component, Vue, Prop } from 'vue-property-decorator';
import authorize, { Director } from '@/services/Authorize';
import moment from 'moment';
import MaterialItem from '@/classes/MaterialItem';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import DetailsCertificateForm from './DetailsCertificateForm.vue';

@Component
export default class ItemsList extends Vue {

    public currPage: number = 1;
    public perPage: number = 10;
    public totalFilteredRows: number | null = null;
    public filter: string | null = null;

    get currentPage(): number {
      if (this.currPage > this.pages) {
        return this.pages;
      } else {
        return this.currPage;
      }
    }

    set currentPage(num: number) {
      this.currPage = num;
    }

    get pages(): number {
      return Math.ceil(this.totalRows / this.perPage);
    }

    get items(): MaterialItem[] {
        return this.$store.getters['material/getMaterialItems'];
    }

    get totalRows(): number {
        if (this.items && this.totalFilteredRows === null) {
            return this.items.length;
        } else if (this.totalFilteredRows !== null) {
            return this.totalFilteredRows;
        } else {
            return 0;
        }
    }

    get fields() {
        return [{
            key: 'categoryName',
            label: 'Category',
            sortable: true
        }, {
            key: 'listItem',
            label: 'List Item',
            sortable: true
        }, {
            key: 'quantityOfStock',
            label: 'Quantity',
            sortable: true
        }, {
            key: 'outOfStock',
            label: 'Out of Stock',
            sortable: true
        }, {
            key: 'created',
            label: 'Date/Time Created',
            sortable: true
        }, {
            key: 'createdById',
            label: 'Created by',
            sortable: true
        }, {
            key: 'editDelete',
            label: ''
        }];
  }

  public onFiltered(filteredItems: MaterialItem[]) {
      this.totalFilteredRows = filteredItems.length;
      this.currentPage = 1;
  }

  public getUserProfileName(id: number) {
    const user = this.$store.getters.getUserProfileById(id);
    if (user) {
      return user.getFullName();
    } else {
      return '';
    }
  }

  public deleteItem(id: string) {
      if (confirm('Delete item?')) {
        const item = new MaterialItem();
        item.id = Number(id);
        this.$store.dispatch('material/deleteMaterialItem', item)
        .then((r: any) => {
            if (!r.success) {
                alert(r.message);
            } else {
                alert('Deleted.');
            }
        })
        .catch((e) => {
            alert(e);
        });
      }
    }
}
